/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.models

import net.scalytica.blaargh.utils.StaticConfig.urlFromRoot
import org.scalajs.dom.ext.Ajax
import io.circe._
import io.circe.parser._
import japgolly.scalajs.react.Callback

import scala.concurrent.Future

import scala.concurrent.ExecutionContext.Implicits.global


case class Author(
    name: String,
    email: String
)

case class Owner(
    name: String,
    avatar: String,
    bio: String,
    email: String,
    disqusShortname: String,
    twitter: String,
    facebook: String,
    instagram: String,
    linkedin: String
)

object Owner {
  val empty: Owner = Owner(
    name = "",
    avatar = "",
    bio = "",
    email = "",
    disqusShortname = "",
    twitter = "",
    facebook = "",
    instagram = "",
    linkedin = ""
  )
}

case class Config(
    siteTitle: String,
    authors: Seq[Author],
    owner: Owner
)

object Config {

  val empty: Config = Config(
    siteTitle = "",
    authors = Seq.empty,
    owner = Owner.empty
  )

  def load(): Future[Config] =
    Ajax.get(url = urlFromRoot("config/config.json")).map {
      xhr =>
        xhr.status match {
          case ok: Int if ok == 200 =>
            parse(xhr.responseText) match {
              case Left(ParsingFailure(message, err)) =>
                // scalastyle:off
                Callback.warn("Failed to load config:\n" + message)
                Callback.warn("Error is:\n" + err.getMessage)
                // scalastyle:on
                empty

              case Right(json) =>
                json.as[Config] match {
                  case Left(err) => throw err
                  case Right(cfg) => cfg
                }
            }

          case _ =>
            empty
        }
    }.recover {
      case e: Throwable =>
        Callback.throwException(e)
        empty
    }

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/models/Config.scala